module.exports = __webpack_public_path__ + "static/img/8seg.0eabfbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/8seg.png
// module id = ShHU
// module chunks = 0